import { FlashList } from '@shopify/flash-list';
import { StyleSheet, View } from 'react-native';

import { ActionSheet, ProductListTile, ProductListTileProps } from '@fhs/ui';

import { AddedToCart } from './added-to-cart';
import { ItemSelectionParams } from './types';

const numColumns = 2;

export const ItemList = ({
  currentStep,
  currentStepSelectedItemId,
  onSelectItem,
}: {
  currentStep: any; // TODO: specify type from use-guide - currentStep
  currentStepSelectedItemId: string;
  onSelectItem: (params: ItemSelectionParams) => void;
}) => {
  const items = currentStep.sections[0]?.items ?? [];
  return (
    <FlashList<ProductListTileProps & { requiresCustomization: boolean; priceCents: number }>
      showsVerticalScrollIndicator={false}
      data={items}
      estimatedItemSize={200}
      numColumns={numColumns}
      renderScrollComponent={ActionSheet.ScrollView}
      contentContainerStyle={{ paddingHorizontal: 12, paddingBottom: 20 }}
      extraData={{ currentStepSelectedItemId }}
      keyExtractor={item => item.id ?? ''}
      renderItem={({ item, index, extraData }) => {
        const isFirstColumn = index % numColumns === 0;
        const isLastColumn = index % numColumns === numColumns - 1;
        return (
          <View
            style={[
              styles.item,
              isFirstColumn && styles.firstColumn,
              isLastColumn && styles.lastColumn,
            ]}
          >
            <ProductListTile
              // @ts-ignore
              size="lg"
              showPriceAndCalories
              {...item}
              onPress={() => {
                onSelectItem({
                  itemId: item.id ?? '',
                  itemSlug: item.slug ?? '',
                  itemName: item.title,
                  requiresCustomization: item.requiresCustomization,
                  image: item.image,
                  price: item.priceCents,
                  baseCalories: item.calories,
                });
              }}
            />
            {extraData.currentStepSelectedItemId === item.id && (
              <View style={styles.addedToCartContainer}>
                <AddedToCart />
              </View>
            )}
          </View>
        );
      }}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    height: '100%',
  },
  title: {
    borderBottomColor: 'rgba(0, 0, 0, 0.04)',
    borderBottomWidth: 1,
    paddingVertical: 16,
    textAlign: 'center',
  },
  item: {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 12,
  },
  firstColumn: {
    paddingLeft: 0,
  },
  lastColumn: {
    paddingRight: 0,
  },
  addedToCartContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
});
